// src/api/petBreed/petBreedApi.ts
import type { ApiResponse, PageContent } from "src/api/common/apiTypes";
import type { PetBreedItem } from "src/store/petBreed";
import { axiosInstance } from "src/api/axiosInstance";
import type { PetBreedUpsertPayload } from "src/components/petBreed/PetBreedUpsertDialog";

export type GetPetBreedListParams = {
  name?: string;
  type?: "DOG" | "CAT" | "";
  useFlag?: "Y" | "N" | "";
  page: number; // 0-based
  size: number;
  order: string;
};

// LIST
export const getPetBreedListApi = async (
  params: GetPetBreedListParams
): Promise<ApiResponse<PageContent<PetBreedItem>>> => {
  const res = await axiosInstance.get<ApiResponse<PageContent<PetBreedItem>>>(
    "/v1/admin/customer/pet-breed/list",
    { params }
  );
  return res.data;
};

// GET BY ID
export const getPetBreedByIdApi = async (id: number): Promise<ApiResponse<PetBreedItem>> => {
  const res = await axiosInstance.get<ApiResponse<PetBreedItem>>(
    `/v1/admin/customer/pet-breed/${id}`
  );
  return res.data;
};

// CREATE
export const createPetBreedApi = async (
  payload: PetBreedUpsertPayload
): Promise<ApiResponse<PetBreedItem>> => {
  const res = await axiosInstance.post<ApiResponse<PetBreedItem>>(
    "/v1/admin/customer/pet-breed",
    payload
  );
  return res.data;
};

// UPDATE
export const updatePetBreedApi = async (
  id: number,
  payload: PetBreedUpsertPayload
): Promise<ApiResponse<PetBreedItem>> => {
  const res = await axiosInstance.put<ApiResponse<PetBreedItem>>(
    `/v1/admin/customer/pet-breed/${id}`,
    payload
  );
  return res.data;
};

// DELETE
export const deletePetBreedApi = async (id: number): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(
    `/v1/admin/customer/pet-breed/${id}`
  );
  return res.data;
};

// GET ACTIVE LIST
export const getActivePetBreedsApi = async (): Promise<ApiResponse<PetBreedItem[]>> => {
  const res = await axiosInstance.get<ApiResponse<PetBreedItem[]>>(
    "/v1/admin/customer/pet-breed/active"
  );
  return res.data;
};

// GET ACTIVE LIST BY TYPE
export const getActivePetBreedsByTypeApi = async (
  type: "DOG" | "CAT"
): Promise<ApiResponse<PetBreedItem[]>> => {
  const res = await axiosInstance.get<ApiResponse<PetBreedItem[]>>(
    `/v1/admin/customer/pet-breed/active/${type}`
  );
  return res.data;
};
